import { Opcion } from '../../../models/catalogo.type'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import {
  schemaRecordatorios,
  TRecordatorioForm,
} from '../../recordatorios/models/recordatorioForm.type'

export type TTareaForm = {
  idSitio?: Opcion | string | any
  idAutorizacion?: Opcion | string | any
  idCondicionante?: Opcion | string | any
  titulo: string
  descripcion: string | any
  estatus: string | any
  idUsuarioAsignado: Opcion | string | any
  fechaInicio: string | any
  fechaTermino: string | any
  recordatorios: TRecordatorioForm[] | []
}

/**
 * Valida tareas operativas creadas desde el modulo de tareas.
 * La tarea siempre debe quedar asociada a un sitio, responsable, estatus y rango
 * de fechas para que pueda aparecer correctamente en listados y calendario.
 */
export const schema = yup.object({
  idSitio: yup.object().required('El sitio es requerido').nullable(),
  titulo: yup.string().trim().required('El título es requerido'),
  descripcion: yup.string().trim().required('La descripción es requerida'),
  estatus: yup.object().required('El estatus es requerido').nullable(),
  idUsuarioAsignado: yup.object().required('El usuario es requerido').nullable(),
  fechaInicio: yup
    .date()
    .default(() => new Date())
    .required('Esta fecha es requerida')
    .nullable(),
  fechaTermino: yup
    .date()
    .default(() => new Date())
    .required('Esta fecha es requerida')
    .nullable(),
})

const schemaConcat = schema.concat(schemaRecordatorios)

/**
 * Combina las reglas propias de tarea con las reglas compartidas de recordatorios.
 */
export const useTareaForm = () => {
  return useForm<TTareaForm>({
    mode: 'all',
    resolver: yupResolver(schemaConcat),
  })
}

export type TTareaComentario = {
  comentarioCierre: string
}

/**
 * Obliga a registrar contexto funcional al cerrar o comentar una tarea.
 */
export const schemaComentario = yup.object({
  comentarioCierre: yup.string().trim().required('El comentario es requerido').nullable(),
})

export const useTareaComentarioForm = () => {
  return useForm<TTareaComentario>({
    mode: 'all',
    resolver: yupResolver(schemaComentario),
  })
}

export const style = {
  borderRadius: '10px',
  background: '#333',
  color: '#fff',
  fontSize: '18px',
}
